import moment from 'moment';

export const formatPeriod = ({start, end}) => `${moment(start).format('MMM Do')}
  ${moment(start).format('HH:mm:ss')} - ${moment(end).format('HH:mm:ss')}`;
